import React from 'react'
import { Page, Text, View, Document, StyleSheet, PDFViewer, Image, Font, Link } from '@react-pdf/renderer';
import logo from "Assets/images/logo.png";
import instaIcon from "Assets/images/reportIntaIcon.png"
import phoneIcon from "Assets/images/reportPhoneIcon.png"
import clickIcon from "Assets/images/reportClickIcon.png"
import parse from 'html-react-parser';
import Html from 'react-pdf-html';
import { userFullName } from 'helpers/common';
// import ProximaNovaRegular from 'Assets/font/ProximaNova-Regular.ttf';
import ProximaNovaRegular from '../../../../Assets/font/proximanova_regular.ttf';
import ProximaNovaBold from '../../../../Assets/font/ProximaNova-Bold.ttf';
import ProximaNovaThin from '../../../../Assets/font/FontsFree-Net-Proxima-Nova-Thin.ttf';
import ProximaNovalight from '../../../../Assets/font/proximanova_light.ttf';
import Proxima_Nova_Semibold from '../../../../Assets/font/fonnts.com-Proxima_Nova_Semibold.ttf';
import ProximaNovaThinItalic from '../../../../Assets/font/FontsFree-Net-Proxima-Nova-Thin-It.otf';
import ProximaNovaLightItalic from '../../../../Assets/font/FontsFree-Net-Proxima-Nova-Light-It.otf';
import ProximaNovaRegularItalic from '../../../../Assets/font/FontsFree-Net-Proxima-Nova-Reg-It.otf';
import ProximaNovaBoldItalic from '../../../../Assets/font/FontsFree-Net-ProximaNovaBoldItalic.ttf';
import ProximaNovaSemiBoldItalic from '../../../../Assets/font/FontsFree-Net-ProximaNovaSemiboldItalic.ttf';
import { ClientDetailsPdf } from "./Components/ClientDetails";
import { PdfFooter } from './Components/PdfFooter';
import TherapistSignaturePdf from "./Components/TherapistSignature";
import { extractUploadFileName } from 'config/constants';
import moment from 'moment';
import PDFHtmlRenderer from "./Components/PDFHtmlRenderer";

Font.register({
    family: 'Proxima Nova',
    fonts: [
        { src: ProximaNovaThin, fontWeight: 'thin' },
        { src: ProximaNovalight, fontWeight: 'light' },
        { src: ProximaNovaRegular, fontWeight: 'regular' },
        { src: Proxima_Nova_Semibold, fontWeight: 'semibold' },
        { src: ProximaNovaBold, fontWeight: 'bold' },
        { src: ProximaNovaThinItalic, fontWeight: 'thin', fontStyle: 'italic' },
        { src: ProximaNovaLightItalic, fontWeight: 'light', fontStyle: 'italic' },
        { src: ProximaNovaRegularItalic, fontWeight: 'normal', fontStyle: 'italic' },
        { src: ProximaNovaSemiBoldItalic, fontWeight: 'semibold', fontStyle: 'italic' },
        { src: ProximaNovaBoldItalic, fontWeight: 'bold', fontStyle: 'italic' },
    ],
});

const styles = StyleSheet.create({
    page: {
        color: "#000",
        padding: 20,
        backgroundColor: '#ffffff',
        fontFamily: 'Proxima Nova',
        paddingTop: 20,
        paddingBottom: 80,
    },
    fontBold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'bold'
    },
    fontSemibold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'semibold'
    },
    fontLight: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'light'
    },
    container: {
        padding: '0 40px 0 40px',
    },
    pageNumber: {
        textAlign: "right",
        paddingBottom: 10,
    },
    border: {
        borderBottom: "1px solid #000",
        paddingBottom: "2px",
        marginBottom: "10px"
    },
    headerRow: {
        flexDirection: 'row',
        alignItems: "flex-end",
        justifyContent: 'space-between',
        marginBottom: 20,
        padding: '0 40px 0 0',
    },
    row: {
        display: "flex",
        flexDirection: "row"
    },
    logo: {
        width: 127,
    },
    headerTitle: {
        textTransform: "uppercase",
        fontSize: 11,
        textAlign: 'center',
        fontWeight: 'bold',
    },
    subtitle: {
        fontSize: 16,
        textAlign: 'center',
        marginTop: 5,
        color: "#93278F"
    },
    text: {
        fontSize: 12,
    },
    mainHeading: {
        fontSize: 10,
        fontWeight: 'semibold',
        fontFamily: 'Proxima Nova',
    },
    subHeading: {
        fontSize: 7,
        fontWeight: 'semibold',
    },
    para: {
        fontSize: 8,
        fontWeight: 300
    },
    section: {
        marginTop: 10,
    },
    halfCol: {
        width: '50%',
        paddingRight: 10,
        marginBottom: 10,
    },
    fullCol: {
        width: '100%',
        paddingRight: 10,
        marginBottom: 10,
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        // textAlign: 'center',
        // fontSize: 10,
        // color: 'grey',
        padding: '0 20px 0 60px',
    },
});

// const pdfData = {
//     lastname: data?.lastname,
//     firstname: data?.firstname,
//     city_town: data?.client_detail?.city_town,
//     dob: dateFormat(data?.client_detail?.dob),
//     grade: data?.client_detail?.grade,
//     reportAreas,
//     schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
//     schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
//     screening_date: values?.screening_date,
//     selectedGuardians,
//     reportHeading
// }

export const DischargeScreeningPdfDocV2 = ({ data }) => {
    return (
        <Document>
            {/* Page 1 */}
            <Page size="A4" style={styles.page}>
                <View
                    style={styles.pageNumber}
                    render={({ pageNumber, totalPages }) => (
                        <Text style={{ ...styles.para }}>Page {pageNumber}/{totalPages}</Text>
                    )}
                    fixed
                ></View>
                <View style={styles.headerRow}>
                    <View>
                        <Image style={styles.logo} src={logo} />
                    </View>
                    <View>
                        <Text style={[styles.headerTitle, { ...styles.fontBold, letterSpacing: "1px" }]}>{data?.therapist?.therapist_discipline?.name}</Text>
                        <Text style={styles.subtitle}>Screening Discharge Report</Text>
                    </View>
                    <View>
                        <Text style={[styles.fontSemibold, { fontSize: 7, color: "#000" }]}>REPORT DATE</Text>
                        <Text style={{ fontSize: 8 }}>{data?.reportDate}</Text>
                    </View>
                </View>

                <View style={styles.container}>
                    <View style={styles.border}>
                        <Text style={{ ...styles.mainHeading, fontSize: 10 }}>CLIENT INFORMATION</Text>
                    </View>
                    <View style={{ ...styles.row, justifyContent: "space-between", marginBottom: "20px" }}>
                        <ClientDetailsPdf
                            data={data}
                            styles={styles}
                        />
                    </View>

                    <View style={{ ...styles.row, alignItems: "flex-start", gap: "30px" }}>
                        <View style={{ width: "35%", paddingTop: "8px" }}>
                            <View style={styles.border}>
                                <Text style={{ ...styles.mainHeading, ...styles.fontSemibold }}>SCHOOL INFORMATION</Text>
                            </View>
                            {/* <View style={styles.border}>
                                <Text style={styles.mainHeading}>Parent/guardian 1</Text>
                            </View> */}
                            <View style={{ ...styles.row, flexWrap: "wrap" }}>
                                <View style={{ ...styles.halfCol }}>
                                    <Text style={{ ...styles.subHeading }}>SCHOOL NAME</Text>
                                    <Text style={{ ...styles.para, marginTop: "3px" }}>{data?.schoolName}</Text>
                                </View>
                                <View style={{ ...styles.halfCol }}>
                                    <Text style={{ ...styles.subHeading }}>LOCATION</Text>
                                    <Text style={{ ...styles.para, marginTop: "3px" }}>{data?.schoolLocation}</Text>
                                </View>
                            </View>
                            {
                                data?.selectedGuardians?.map((item) => <>
                                    <View style={{ borderBottom: "0.25px solid #000", paddingBottom: "2px", marginBottom: "8px" }}>
                                        <Text style={{ ...styles.mainHeading, textTransform: "capitalize", letterSpacing: "1px", textTransform: "uppercase" }}>{item?.key}</Text>
                                    </View>
                                    <View style={{ ...styles.row, flexWrap: "wrap" }}>
                                        <View style={{ ...styles.halfCol }}>
                                            <Text style={{ ...styles.subHeading }}>FIRST NAME</Text>
                                            <Text style={{ ...styles.para, marginTop: "3px" }}>{item?.client_guardian?.firstname}</Text>
                                        </View>
                                        <View style={{ ...styles.halfCol }}>
                                            <Text style={{ ...styles.subHeading }}>LAST NAME</Text>
                                            <Text style={{ ...styles.para, marginTop: "3px" }}>{item?.client_guardian?.lastname}</Text>
                                        </View>
                                        <View style={{ ...styles.fullCol }}>
                                            <Text style={{ ...styles.subHeading }}>EMAIL ADDRESS</Text>
                                            <Text style={{ ...styles.para, color: "#315D99", textDecoration: "underline", marginTop: "3px" }}>{item?.client_guardian?.email}</Text>
                                        </View>
                                        {/* <View style={{ ...styles.halfCol }}>
                                            <Text style={{ ...styles.subHeading }}>CITY/TOWN</Text>
                                            <Text style={styles.para}>Edmonton</Text>
                                        </View>
                                        <View style={{ ...styles.halfCol }}>
                                            <Text style={{ ...styles.subHeading }}>Parent Present</Text>
                                            <Text style={styles.para}>Yes</Text>
                                        </View> */}
                                    </View >
                                </>)
                            }
                            <View style={{ ...styles.border, ...styles.section }}>
                                <Text style={styles.mainHeading}>CLINICIAN INFORMATION</Text>
                            </View>
                            <TherapistSignaturePdf
                                data={data}
                            />
                        </View>

                        <View style={{ width: "65%" }}>
                            <View style={{ ...styles.border, display: "flex", flexDirection: "row", alignItems: "flex-end", justifyContent: "space-between", marginBottom: "7px" }}>
                                <Text style={{ ...styles.mainHeading }}>SCREENING RESULTS</Text>
                                <View style={{ alignItems: "flex-end" }}>
                                    <Text style={{ ...styles.subHeading, marginBottom: "3px" }}>SCREENING DATE</Text>
                                    <Text style={{ ...styles.para }}>{moment(data?.screening_date).isValid() ? data?.screening_date : "--"}</Text>
                                </View>
                            </View>
                            <View>
                                {
                                    data?.reportAreas?.map((item) => (
                                        <View style={{ marginBottom: 10 }}>
                                            <View style={{ borderBottom: "0.25px solid #000", paddingBottom: "2px", marginBottom: "6px", ...styles.row, alignItems: "center", gap: "2px" }}>
                                                <Text style={{ ...styles.mainHeading, letterSpacing: "1px" }}>AREA:</Text>
                                                <Text style={{ fontSize: 10, letterSpacing: "1px", textTransform: "uppercase" }}>{item?.area?.label} </Text>
                                            </View >
                                            <View style={{ marginBottom: 5 }}>
                                                <PDFHtmlRenderer
                                                    style={{ ...styles.para, fontSize: 10, }}
                                                    data={item?.area_description}
                                                />
                                            </View>
                                            {item?.attachmentData?.length && (
                                                <View>
                                                    <View>
                                                        <Text style={styles.subHeading}>ATTACHMENTS</Text>
                                                    </View>
                                                    <View style={{ paddingLeft: "5px" }}>
                                                        {item?.attachmentData?.map((item, index) => (
                                                            <Link
                                                                key={index}
                                                                src={item?.attachment_name}
                                                                style={{ ...styles.para, color: "#000", textDecoration: "underline", marginTop: "3px", width: "100%", overflow: "hidden" }}
                                                            >
                                                                {`${index + 1}. ${extractUploadFileName(item?.attachment_name)}`}
                                                            </Link>
                                                        ))}
                                                    </View>
                                                </View>
                                            )}
                                        </View>
                                    ))
                                }
                            </View>
                        </View>
                    </View>
                </View>
                <PdfFooter data={data} />
            </Page>
        </Document >
    )
}